import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { UwActionLog } from './uw-action-log-metadata';
import { PaginationOptions } from '@uw/core/models/filter.model';
import { DefaultPaginationOptions } from '@uw/core/utils/pagination-util';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { IsLoadedListMetadata } from '@uw/core/models/is-loaded-list-metadata.model';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { NgClass } from '@angular/common';
import { NoRecordContainerComponent } from '../no-record-container/no-record-container.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'uw-action-log-history',
    templateUrl: './uw-action-log-history.component.html',
    styleUrls: ['./uw-action-log-history.component.scss'],
    host: {
        '[class.uw-action-log-history]': 'true'
    },
    imports: [MatAccordion, MatExpansionPanel, NgClass, MatExpansionPanelHeader, MatExpansionPanelTitle, MatPaginator, NoRecordContainerComponent, TranslateModule]
})
export class UwActionLogHistoryComponent {

  @Input()
  actionLogMetadata: IsLoadedListMetadata<UwActionLog> | null = null;

  @Input()
  title!: string;

  @Input()
  paginationOptions: PaginationOptions = DefaultPaginationOptions;

  @Output()
  pageChange = new EventEmitter<PageEvent>();
  
  length!: number;
  pageSize!: number;
  pageIndex!: number;

  ngOnChanges(changes: SimpleChanges): void {
    

    if (changes && changes.paginationOptions && changes.paginationOptions.currentValue) {
      this.pageIndex =
        this.paginationOptions.page !== undefined &&
        this.paginationOptions.page > 0
          ? this.paginationOptions.page - 1
          : 0;
      this.pageSize = this.paginationOptions.limit
        ? this.paginationOptions.limit
        : 10;

      if (this.paginationOptions.length) {
        this.length = this.paginationOptions.length;
      }
    }
  }

}
